/*
 * LE BANDIERE SI DISEGNANO, SU QUESTA MACCHINA?
 *
 * Qui si decide se accendere il font di sole bandiere: si mette
 * `data-flag-font="twemoji"` su <html>, e il blocco in fondo a `index.css`
 * prefissa la famiglia agli stack dell'app. Il perche' del rimedio sta in
 * `flag-font.css`; qui c'e' solo il come lo si riconosce.
 *
 * SI MISURA, NON SI INDOVINA DALLO USER-AGENT. La discriminante non e' "Windows"
 * ma "mancano i glifi": su Windows Firefox le bandiere le mostra (ricade sul suo
 * Twemoji Mozilla) e non deve scaricare niente, mentre una Linux senza font
 * emoji con bandiere e' rotta quanto Chrome su Windows e deve essere servita.
 * Nessuno sniffing azzecca quella riga; una misura si'.
 *
 * LA MISURA. Un'emoji bandiera e' una COPPIA di indicatori regionali
 * (🇨🇭 = U+1F1E8 U+1F1ED). Se il font ha il glifo della coppia, la coppia e' UN
 * glifo e misura quanto un'emoji sola; se non ce l'ha, sono DUE glifi — le due
 * lettere — e misura il doppio. Quindi basta il rapporto fra la larghezza della
 * coppia e quella di un indicatore singolo:
 *
 *     ~1,0  -> un glifo solo: la bandiera c'e', non si fa nulla
 *     ~2,0  -> due glifi: si vedono "CH", si accende il font
 *
 * Il margine non e' teorico. Misurato con Chromium su una macchina con
 * NotoColorEmoji (bandiere presenti): coppia 39,93px, singolo 39,93px, e per
 * confronto 🌍 39,93px — rapporto esatto 1,0. Nel caso rotto la coppia e' per
 * definizione la somma dei due glifi. La soglia a 1,5 sta in mezzo con tutto lo
 * spazio che serve.
 *
 * Si misura con lo stack di `html, body`, non con `sans-serif`: la ricaduta su
 * un font emoji dipende dal punto di partenza, e il punto di partenza dell'app
 * e' quello.
 *
 * COME SI PROVA IL RAMO ROTTO SENZA UN WINDOWS. Una macchina Linux con
 * NotoColorEmoji le bandiere ce l'ha, quindi questo file li' non fa mai niente
 * e lo si proverebbe solo a parole. Il ramo rotto si ottiene togliendo quel
 * font al browser, con un fontconfig che lo rifiuta:
 *
 *     <fontconfig>
 *       <include ignore_missing="yes">/etc/fonts/fonts.conf</include>
 *       <selectfont><rejectfont>
 *         <glob>/usr/share/fonts/truetype/noto/NotoColorEmoji.ttf</glob>
 *       </rejectfont></selectfont>
 *     </fontconfig>
 *
 * e lanciando il browser con `FONTCONFIG_FILE=<quel file>` (NON lo snap: gira
 * confinato e la variabile non lo raggiunge; va bene il Chromium della cache di
 * Playwright, `scripts/lib/find-chromium.mjs`). Con quella configurazione la
 * misura passa da 1,0 a 2,0 e l'app accende il font da sola.
 *
 * OGNI RICADUTA PORTA A "LE BANDIERE VANNO BENE". Canvas assente (jsdom),
 * contesto 2d negato, larghezze a zero, qualunque eccezione: non si accende
 * nulla e resta il comportamento di oggi. Il peggio che questo file puo' fare e'
 * non fare niente — mai una schermata peggiore di quella che c'e' gia'.
 */

/* Lo stesso stack della regola `html, body` di index.css. Se cambia la', qui va
   aggiornato: `__tests__/font-bandiere.test.ts` fallisce se divergono. */
const STACK_MISURA =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', " +
  "'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";

/* Svizzera: una bandiera qualsiasi, purche' esista in ogni font che ne abbia. */
const COPPIA = '\u{1F1E8}\u{1F1ED}';
const INDICATORE_SINGOLO = '\u{1F1E8}';

/* In mezzo fra l'1,0 del caso sano e il 2,0 del caso rotto. */
const SOGLIA = 1.5;

export const ATTRIBUTO = 'data-flag-font';
export const VALORE = 'twemoji';

/** `true` se questa piattaforma disegna le emoji bandiera (o se non si puo' sapere). */
export function bandiereDisegnate(): boolean {
  try {
    if (typeof document === 'undefined') return true;
    const contesto = document.createElement('canvas').getContext('2d');
    if (!contesto) return true;

    contesto.font = `32px ${STACK_MISURA}`;
    const coppia = contesto.measureText(COPPIA).width;
    const singolo = contesto.measureText(INDICATORE_SINGOLO).width;
    /* Zero, NaN, undefined: canvas che non misura davvero. Non si conclude nulla. */
    if (!coppia || !singolo) return true;

    return coppia / singolo < SOGLIA;
  } catch {
    return true;
  }
}

/**
 * Accende il font di sole bandiere se e solo se serve.
 * Torna `true` se l'ha acceso. Da chiamare prima del primo disegno.
 */
export function accendiFontBandiere(): boolean {
  try {
    if (bandiereDisegnate()) return false;
    document.documentElement.setAttribute(ATTRIBUTO, VALORE);
    return true;
  } catch {
    return false;
  }
}
